import { Component, OnInit, Input } from '@angular/core';
import { IWizardContentComponent } from '../../../../wizard.content';
import {WizardComponent} from "../../../../wizard.component";

@Component({
  selector: 'user-update-results',
  templateUrl: './user.update.results.template.html',
  styleUrls: ['./user.update.results.style.scss']
})
export class UpdateUserResultsComponent implements IWizardContentComponent {

  @Input() step: object;
  @Input() subStep: object;
  @Input() wizardCtrl: WizardComponent;
  @Input() id: string;
  @Input() previousOutput: object;

  constructor() { }

  requestFailed() {
    return this.wizardCtrl.getWizardService().requestFailed;
  }

  returnErrorMessage() {
    return this.wizardCtrl.getWizardService().errorMessage;
  }

  get errorCauseMessage() {
    return this.wizardCtrl.getWizardService().errorDescription;
  }

  returnSuccessMessage() {
    return this.wizardCtrl.getWizardService().successMessage;
  }

}
